// extracted by mini-css-extract-plugin
export default {"search_list":"SearchList_search_list__MnvuR","search_mobile":"SearchList_search_mobile__tJv0J","icon":"SearchList_icon__z39ho","cancel":"SearchList_cancel__FMuJN"};